import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { offersService } from '../services/offersService';
import { toast } from 'react-hot-toast';

export const useCompanyOffers = () => {
    const queryClient = useQueryClient();

    const { data: allOffers = [], isLoading: loadingAll } = useQuery({
        queryKey: ['companyOffers'],
        queryFn: () => offersService.getCompanyOffers().then(res => res.data.data),
    });

    const { data: acceptedOffers = [], isLoading: loadingAccepted } = useQuery({
        queryKey: ['acceptedOffers'],
        queryFn: () => offersService.getAcceptedOffers().then(res => res.data.data),
    });

    const createMutation = useMutation({
        mutationFn: ({ quoteId, data }) => offersService.createOffer(quoteId, data),
        onSuccess: () => {
            toast.success('Offer created successfully!');
            queryClient.invalidateQueries(['companyOffers']);
            queryClient.invalidateQueries(['availableQuotes']);
        },
        onError: () => toast.error('Failed to create offer'),
    });

    const updateMutation = useMutation({
        mutationFn: ({ offerId, data }) => offersService.updateOffer(offerId, data),
        onSuccess: () => {
            toast.success('Offer updated!');
            queryClient.invalidateQueries(['companyOffers']);
        },
    });

    const deleteMutation = useMutation({
        mutationFn: (offerId) => offersService.deleteOffer(offerId),
        onSuccess: () => {
            toast.success('Offer deleted');
            queryClient.invalidateQueries(['companyOffers']);
        },
    });

    return {
        allOffers,
        acceptedOffers,
        loadingAll,
        loadingAccepted,
        createOffer: createMutation.mutate,
        isCreating: createMutation.isPending,
        updateOffer: updateMutation.mutate,
        deleteOffer: deleteMutation.mutate,
        isDeleting: deleteMutation.isPending,
    };
};